import { render, staticRenderFns } from "./ModelInfo1.vue?vue&type=template&id=5c639b09&scoped=true"
import script from "./ModelInfo1.vue?vue&type=script&lang=ts"
export * from "./ModelInfo1.vue?vue&type=script&lang=ts"
import style0 from "./ModelInfo1.vue?vue&type=style&index=0&id=5c639b09&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c639b09",
  null
  
)

export default component.exports